import React, { useContext } from "react";
import TenantContext from "./../OnlineFormContext";

function Banner(props) {
  const contextValues = useContext(TenantContext);
  
  return <div className="nine wide column bg-section" style={{ backgroundImage: `url(${contextValues.banner})` }}></div>;
}

export default Banner;
